var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCalendarIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.835 7.50163H0.835007M11.6683 0.834961V4.16829M5.00167 0.834961V4.16829M4.83501 17.5016H11.835C13.2351 17.5016 13.9352 17.5016 14.47 17.2291C14.9404 16.9895 15.3228 16.607 15.5625 16.1366C15.835 15.6018 15.835 14.9018 15.835 13.5016V6.50163C15.835 5.1015 15.835 4.40143 15.5625 3.86665C15.3228 3.39625 14.9404 3.01379 14.47 2.77411C13.9352 2.50163 13.2351 2.50163 11.835 2.50163H4.83501C3.43488 2.50163 2.73481 2.50163 2.20003 2.77411C1.72963 3.01379 1.34717 3.39625 1.10749 3.86665C0.835007 4.40143 0.835007 5.1015 0.835007 6.50163V13.5016C0.835007 14.9018 0.835007 15.6018 1.10749 16.1366C1.34717 16.607 1.72963 16.9895 2.20003 17.2291C2.73481 17.5016 3.43488 17.5016 4.83501 17.5016Z",
    stroke: "#344054",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCalendarIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/calendar-icon.4ad76b791a14a094bd698beae018b8e0.svg";